import { withTranslation } from 'react-i18next';
import { BaseNodeComponent, PropsWithContext } from '@jsplumbtoolkit/browser-ui-react';
import { CustomIconFont } from 'icons';

import BaseOverflowTooltip from 'components/common/overflow-tooltip/BaseOverflowTooltip';
import { classnames } from 'lib/classnames';
import { WorkFlowStatusColor } from 'lib/global';

import { anchors, PlumbNode } from '../config';

import Port from './Port';

import styles from './index.module.less';

const cx = classnames(styles);
const TagIcons = {
  checkIn: 'SignIn',
  approval: 'Approval-Filled',
  all: 'NumberTwo',
};

interface TaskNodeProps {
  setSelected?: (id: string, selected: boolean, isAny?: boolean) => void;
  updateNodePosition: (id: string, position: number[]) => void;
  viewer?: boolean;
  data: PlumbNode;
  errorFlag?: boolean;
  anyClick: () => void;
  t: any;
}

class TaskNode extends BaseNodeComponent<TaskNodeProps & PropsWithContext, { disabledTooltip: boolean }> {
  anyColor: string;
  bgColor: string;
  color: string;
  selected: boolean;
  constructor(props: TaskNodeProps & PropsWithContext) {
    super(props);
    this.bgColor = WorkFlowStatusColor[props.data.key].bgColor;
    this.color = WorkFlowStatusColor[props.data.key].color;

    this.anyColor = '#DADDE3';
    this.selected = false;
    this.state = { disabledTooltip: false };
  }

  selectHandle = (e: MouseEvent, handler?: boolean): boolean => {
    e.stopPropagation();
    e.preventDefault();
    if (handler) {
      this.props?.anyClick();
    }
    return false;
  };

  shouldComponentUpdate(nextProps: TaskNodeProps): boolean {
    return this.props.data.anyTag === nextProps.data.anyTag;
  }

  render(): React.ReactElement {
    const { t } = this.props;
    let icon = null;
    if (this.props.data.approved && this.props.data.checked) {
      icon = TagIcons.all;
    } else if (this.props.data.approved && !this.props.data.checked) {
      icon = TagIcons.approval;
    } else if (!this.props.data.approved && this.props.data.checked) {
      icon = TagIcons.checkIn;
    }

    return (
      <>
        <div
          className={cx('flow-node-wrapper', this.props.data.key.toLocaleLowerCase(), {
            'view-node': this.props.viewer,
            'error-type': this.props.data.errorFlag,
          })}
        >
          <div
            id={this.props.data.id}
            className={cx('flow-node', {
              selected: this.selected,
              'node-selected': this.selected,
            })}
            style={{
              backgroundColor: this.bgColor,
              color: this.color,
            }}
          >
            <div
              className={cx('node-content')}
              onMouseDown={() => this.setState({ disabledTooltip: true })}
              onMouseUp={() => this.setState({ disabledTooltip: false })}
            >
              <BaseOverflowTooltip maxline={2} title={this.props.data.name} className={cx('node-name')}>
                {this.props.data.name}
              </BaseOverflowTooltip>
              {anchors.map(item => {
                return (
                  <Port
                    key={this.props.data.id + item}
                    node={this.props.data}
                    type={item}
                    toolkit={this.toolkit}
                    surface={this.surface}
                    vertex={this.vertex}
                  />
                );
              })}
            </div>
            {icon && (
              <div className={cx('approval-wrapper')}>
                <div className={cx('approval-icon', this.props.data.key.toLocaleLowerCase())}>
                  <CustomIconFont type={icon} className={cx('approval-filled')} />
                </div>
              </div>
            )}
          </div>
        </div>
        {this.props.data.anyTag && (
          <div
            className={cx('any-status', { 'any-selected': this.props.data.selectedAny })}
            onMouseUp={(e: any) => this.selectHandle(e, true)}
            onMouseDown={(e: any) => this.selectHandle(e)}
          >
            <svg width="9" height="50" className={cx('content')} id="path">
              <path pointerEvents="all" d="M4.5,0 L8.5,8 L0.5,8 L4.5,0" stroke={this.anyColor} fill={this.anyColor} />
              <line x1="4.5" y1="0.5" x2="4.5" y2="50" stroke={this.anyColor} strokeWidth="1" />
            </svg>
            <BaseOverflowTooltip
              className={cx('text')}
              title={t('formField.anyStatus')}
              id="text"
              onClick={e => {
                const ev = e || window.event;
                console.info('any status', e);
                ev.stopPropagation();
                ev.preventDefault();
                console.info('any status after', e);
                return false;
              }}
            >
              {t('formField.anyStatus')}
            </BaseOverflowTooltip>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(TaskNode);
